import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const AdminOnly = ({ children }) => {
  const { userType } = useAuth();
  if (userType === 'user') return <Navigate to="/" replace />;
  return children;
};

export default AdminOnly;
